import { jsPDF } from "jspdf";

export const RESUME_TEMPLATES = [
  { id: "classic", name: "Classic", description: "Traditional serif · balanced spacing", font: "times", color: "#172B3A" },
  { id: "modern", name: "Modern", description: "Navy accents · clean sans-serif", font: "helvetica", color: "#142D4E" },
  { id: "compact", name: "Compact", description: "Smaller type · space-saving layout", font: "helvetica", color: "#172B3A" },
];

export const resumeSections = (f) => [
  ["Summary", f.bio], ["Skills", f.skills], ["Experience", f.experience], ["Education", f.education],
];

export function buildResumePdf(f, templateId) {
  const template = RESUME_TEMPLATES.find((t) => t.id === templateId) || RESUME_TEMPLATES[0];
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const compact = template.id === "compact";
  const modern = template.id === "modern";
  const W = doc.internal.pageSize.getWidth();
  const H = doc.internal.pageSize.getHeight();
  const margin = compact ? 40 : 48;
  const bodySize = compact ? 10 : 11;
  const leading = compact ? 13 : 16;
  let y = modern ? 65 : 56;
  const decorate = () => {
    if (modern) { doc.setFillColor(template.color); doc.rect(0, 0, W, 12, "F"); }
  };
  const ensureSpace = (height) => {
    if (y + height > H - margin) { doc.addPage(); decorate(); y = 56; }
  };
  const write = (text, size, bold, lineHeight, color = "#172B3A") => {
    doc.setFont(template.font, bold ? "bold" : "normal");
    doc.setFontSize(size); doc.setTextColor(color);
    for (const line of doc.splitTextToSize(String(text), W - 2 * margin)) {
      ensureSpace(lineHeight);
      doc.text(line, margin, y);
      y += lineHeight;
    }
  };
  decorate();
  write(f.name || "Your Name", compact ? 22 : 28, true, compact ? 26 : 32, template.color);
  if (f.headline) write(f.headline, 12, false, 18);
  const contact = [f.email, f.location].filter(Boolean).join("  |  ");
  if (contact) write(contact, 10, false, 16);
  ensureSpace(28);
  y += 4; doc.setDrawColor(modern ? template.color : "#CBD5E1");
  doc.line(margin, y, W - margin, y); y += compact ? 18 : 24;
  for (const [title, body] of resumeSections(f)) {
    if (!body?.trim()) continue;
    ensureSpace(leading + 24);
    write(title.toUpperCase(), 11, true, 19, template.color);
    write(body, bodySize, false, leading);
    y += compact ? 10 : 18;
  }
  const pages = doc.getNumberOfPages();
  for (let page = 1; page <= pages; page++) {
    doc.setPage(page); doc.setFont("helvetica", "normal"); doc.setFontSize(8); doc.setTextColor("#526273");
    doc.text(`${page} / ${pages}`, W - margin, H - 22, { align: "right" });
  }
  return doc;
}
